import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  renderTicketReadmoreDetails,
} from "../../utils/common/common";

const PageDetails = (props: any) => {
  const { detailRow, pageType } = props;
  return (
    <Box className="user-reports tickets">
      {detailRow?.pageURL && Object.keys(detailRow.pageURL).length > 0 && (
        <Accordion defaultExpanded>
          <AccordionSummary
            aria-controls={"panel1-content"}
            id={"panel1-header"}
          >
            <Typography className="title-sm1 accordianTitle">
              page details
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {detailRow?.pageURL && Object.keys(detailRow.pageURL).length > 0 ? (
              <Grid container spacing={2}>
                {renderTicketReadmoreDetails(detailRow?.pageURL)}
              </Grid>
            ) : (
              ""
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default withSnackbar(PageDetails);
